module.exports = __webpack_public_path__ + "static/media/PoAs-116-ZPPCK_Formoplast_clean.42d0ec82.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/PoAs-116-ZPPCK_Formoplast_clean.pdf
// module id = 149
// module chunks = 0